<!-- The product card is owned by the commerce team -->
<script setup lang="ts">
import { computed } from 'vue'

import { ProductCard } from '@toni/commerce-ui'

import { useContentBlock } from '../../content-blocks/composables/use-content-block'
import { useContentBlockStore } from '../../content-blocks/stores/content-block-store'

const props = defineProps<{ id: string }>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'productCard')

const contentBlockStore = useContentBlockStore()

const blocks = contentBlockStore.contentBlockList.filter(item => item.type !== '__injected_ad__' && item.type !== '__injected_related__')

const productCardIndex = blocks.findIndex(item => item.id === props.id)
</script>

<template>
  <ProductCard v-bind="contentBlock.data.productCard"
               :product-card-index="productCardIndex"
               :content-blocks="blocks.map(item => item.type)" />
</template>
